import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import cx from 'classnames'

import Layout from 'src/components/Layout/Layout/index'
import { Left, Body, Right } from 'src/components/Layout/Header'
import SvgIcon from 'src/components/SvgIcon'
import HeaderDropdown from 'src/components/Layout/Header/Dropdown'
import { WidgetContext } from 'src/modules/App/WidgetContext'

import styles from "./HeaderMain.module.less"

const { Header } = Layout

class HeaderMain extends PureComponent {
  static propTypes = {
    title: string
  }

  static defaultProps = {
    title: null,
  }

  closeWidget = () => {
    const { handleCloseWidget } = this.props

    if (typeof handleCloseWidget === 'function') {
      handleCloseWidget()
    }
  }

  render() {
    const { title, brand, isWidgetFullSize, isHome } = this.props

    const pageTitle = title || brand.name

    const classNames = cx({
      'c-layout-header-main': true,
      [styles.header]: true,
      [styles.notOnHomePage]: isHome !== true,
      'kiosk-color--desktop-brand-background': true,
      'kiosk-color--brand-contrast-color': true,
    })

    return (
      <Header className={classNames}>
        <Left className={styles.headerLeft}>
          {isWidgetFullSize && (
            <SvgIcon type="RemoveThinner" className={styles.closeWidgetIcon} onClick={this.closeWidget} />
          )}
          {brand.logo ? (
            <div className={styles.hideOnMobile}><img className={styles.headerLogo} src={brand.logo} alt="logo" /></div>
          ) : (
            <h1 className={styles.headerTitle + ' kiosk-color--brand-contrast-color ' + styles.hideOnMobile}>{pageTitle}</h1>
          )}
        </Left>
        <Body className={styles.headerBody} data-cy="headerTitle">{pageTitle}</Body>
        <Right className={styles.headerRight}>
          <HeaderDropdown refKey="dropdown-header-main-language" hideOnMobile={true} isLanguageMenu={true} />
          <HeaderDropdown refKey="dropdown-header-main-login-link" hideOnMobile={true} isLoginLink={true} />
          <HeaderDropdown refKey="dropdown-header-main-desktop" hideOnMobile={true} isLoggedInUserMenu={true} />
          <HeaderDropdown refKey="dropdown-header-main-mobile" hideOnDesktop={true} />
        </Right>
      </Header>
    )
  }
}

const HeaderMainContext = (props) => (
  <WidgetContext.Consumer>
    {context => <HeaderMain { ...props } { ...context } />}
  </WidgetContext.Consumer>
);

export default HeaderMainContext
